import React from 'react'
import { Section, Image, Link } from 'newComponents'
import { ReactComponent as Circles } from '../../../images/home/home-posts-circle.svg'
import './styles.scss'

const HomeCards = (props) => {
  const { title, cards } = props

  const titleHtml = title?.html

  return (
    <Section className="home-cards">
      <Circles className="home-cards-left-circles" />
      {titleHtml && <div className="home-cards-title" dangerouslySetInnerHTML={{ __html: titleHtml }} />}
      <div className="home-cards-grid">
        {cards.map((item) => {
          const {
            explore_image: image,
            explore_link: link,
            explore_tagline: tagline,
            explore_title: exploreTitle
          } = item
          return (
            <div className="home-cards-post" key={exploreTitle?.text}>
              <Link to={`${link?.url}`} className="home-cards-img-link">
                <Image className="home-cards-post-img" image={image} />
              </Link>
              {tagline?.html && (
                <div className="home-cards-tagline" dangerouslySetInnerHTML={{ __html: tagline?.html }} />
              )}
              <Link to={`${link?.url}`} className="home-cards-post-title">
                {exploreTitle?.text}
              </Link>
            </div>
          )
        })}
      </div>
    </Section>
  )
}

export default HomeCards
